<template>
  <div>
    <v-container fluid>
      <v-row class="mt-16" v-if="logedInUserInfo.rol == 2">
        <!-- este row solo se muestra si es usuario mostrador ya que para
         admin no se ocupa que haya margena arriba -->
      </v-row>
      <v-row>
        <v-col cols="12" lg="6" xl="8">
          <div class="d-flex" style="display:inline-block;">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              dense
              label="Búsqueda..."
              v-model="textoBusqueda"
              single-line
              clearable
              @input="consultaFraccionesArancelarias"
              solo
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="3" xl="2">
          <v-select
            outlined
            dense
            style="margin-bottom: -37px;"
            :items="itemsPaginas"
            label="Elementos por página"
            v-model="itemsPerPage"
            @input="actualizaItemsPerPAge($event)"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="3" xl="2">
          <v-btn color="primary" block dark @click="dialogNuevaFraccionArancelaria = true"
            >Nueva fracción arancelaria</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert v-if="mostrarErrorCarga" outlined type="error">
            Hubo un problema cargando la información, revise su conexión a internet e intente
            nuevamente.
          </v-alert>
          <v-data-table
            :loading="this.tableLoading"
            :headers="headers"
            loading-text="Cargando... por favor espere."
            :items="this.fraccionesA"
            :page.sync="page"
            class="elevation-1"
            hide-default-footer
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
          >
            <template #item.actions="{ item }">
              <v-btn color="blue" class="mr-2" @click="editarFraccionAx(item)" text rounded dark>
                Editar
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn color="red" rounded dark @click="eliminarFraccionA(item.ID)" text>
                Borrar
                <v-icon small class="mr-2">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-pagination
            @input="consultaFraccionesArancelarias(1)"
            v-model="page"
            :length="this.totalPaginas"
          ></v-pagination>
        </v-col>
        <v-snackbar
          v-model="snackbarExito"
          timeout="2000"
          rounded="pill"
          centered
          elevation="8"
          color="blue darken-1"
          ><span style="font-size:20px;">
            {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
          </span></v-snackbar
        >
      </v-row>
      <ModalNuevaFraccionA
        v-if="dialogNuevaFraccionArancelaria"
        :show="dialogNuevaFraccionArancelaria"
        :fraccionPasada="objetoFraccionAEditar"
        @editarFracciona="ejecutarEditarFracciona($event)"
        @cerrarModalFraccion="cerrarModalAgregarFraccionA()"
        @insertaFracciona="insertarFraccionA($event)"
      />
      <ModalConfirmarEliminacion
        :show="dialogConfirmarEliminacion"
        v-if="dialogConfirmarEliminacion"
        @cerrarModalFraccion="dialogConfirmarEliminacion = false"
        @confirmarEliminacionFraccionA="confirmarEliminacionFraccionA()"
      />
      <ModalErrorEnAccion
        :mensajeError="mensajeErrorModalErrorEnAccion"
        :show="dialogErrorEnAccion"
        @cerrarModalEnAccion="dialogErrorEnAccion = false"
      />
    </v-container>
    <v-overlay :value="loaderFraccionesArancelariasx">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import _ from "lodash";
import ModalNuevaFraccionA from "@/components/modales/ModalNuevaFraccionA.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import { mapActions, mapState } from "vuex";

export default {
  beforeDestroy() {
    this.destroyFraccionesAStore();
  },
  methods: {
    ...mapActions("fraccionesarancelarias", [
      "getFraccionasA",
      "insertFraccionasA",
      "deleteFraccionasA",
      "editFraccionasA",
      "destroyFraccionesAStore"
    ]),
    async ejecutarEditarFracciona(objetoFA) {
      const res = await this.editFraccionasA(objetoFA);
      if (res[0]) {
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Fracción arancelaria editada con éxito";
        this.dialogNuevaFraccionArancelaria = false;
        this.consultaFraccionesArancelarias(0);
        this.objetoFraccionAEditar = {};
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
      }
    },
    cerrarModalAgregarFraccionA() {
      this.dialogNuevaFraccionArancelaria = false;
      this.objetoFraccionAEditar = {};
    },
    editarFraccionAx(registroFraccionA) {
      this.objetoFraccionAEditar = registroFraccionA;
      this.dialogNuevaFraccionArancelaria = true;
    },

    consultaFraccionesArancelarias: _.debounce(async function(data = 0) {
      if (data === 1) {
      } else {
        this.page = 1;
      }
      this.tableLoading = true;
      if (this.textoBusqueda != "") {
        const res = await this.getFraccionasA({
          pag: this.page,
          regPag: this.itemsPerPage,
          textoBusqueda: this.textoBusqueda
        });
        if (res[0]) {
          this.tableLoading = false;
          this.mostrarErrorCarga = false;
        } else if (res[1] === "errorcarga") {
          this.mostrarErrorCarga = true;
          this.tableLoading = false;
        }
      } else {
        const res = await this.getFraccionasA({
          pag: this.page,
          regPag: this.itemsPerPage
        });
        if (res[0]) {
          this.tableLoading = false;
          this.mostrarErrorCarga = false;
        } else if (res[1] === "errorcarga") {
          this.mostrarErrorCarga = true;
          this.tableLoading = false;
        }
      }
    }, 400),
    actualizaItemsPerPAge(data) {
      this.page = 1;
      this.itemsPerPage = data;
      this.consultaFraccionesArancelarias(0);
    },
    async insertarFraccionA(data) {
      const res = await this.insertFraccionasA(data);
      if (res[0]) {
        this.mensajeSnackbarExito = "Fracción arancelaria insertada con éxito";
        this.snackbarExito = true;
        this.dialogNuevaFraccionArancelaria = false;
        this.consultaFraccionesArancelarias(0);
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
      }
    },
    async confirmarEliminacionFraccionA() {
      this.loaderFraccionesArancelariasx = true;
      const res = await this.deleteFraccionasA(this.idItemABorrar);
      if (res[0]) {
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Fracción arancelaria eliminada con éxito";
        this.consultaFraccionesArancelarias(0);
        this.dialogConfirmarEliminacion = false;
        this.loaderFraccionesArancelariasx = false;
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
        this.loaderFraccionesArancelariasx = false;
      }
    },
    async eliminarFraccionA(data) {
      this.idItemABorrar = data;
      this.dialogConfirmarEliminacion = true;
    }
  },
  components: {
    ModalErrorEnAccion,
    ModalNuevaFraccionA,
    ModalConfirmarEliminacion
  },
  data: () => ({
    loaderFraccionesArancelariasx: false,
    mostrarErrorCarga: false,
    mensajeErrorModalErrorEnAccion: "",
    mensajeSnackbarExito: "",
    snackbarExito: false,
    dialogConfirmarEliminacion: false,
    dialogErrorEnAccion: false,
    objetoFraccionAEditar: {},
    textoBusqueda: "",
    itemsPaginas: [5, 10, 15, 50],
    idItemABorrar: 0,
    dialogNuevaFraccionArancelaria: false,
    tableLoading: false,
    page: 1,
    itemsPerPage: 10,
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: true,
        value: "NOMBRE"
      },
      {
        text: "Clave",
        align: "start",
        sortable: true,
        value: "NUM_CLASIFICACION"
      },
      {
        text: "Descripcion",
        align: "start",
        sortable: true,
        value: "DES_ES"
      },
      {
        text: "Descripcion inglés",
        align: "start",
        sortable: true,
        value: "DES_EN"
      },
      {
        text: "",
        align: "start",
        sortable: true,
        value: "actions"
      }
    ]
  }),
  async mounted() {
    await this.consultaFraccionesArancelarias(0);
    // this.tableLoading = true;
    // await this.getFraccionasA({ pag: this.page, regPag: this.itemsPerPage });
    // this.tableLoading = false;
  },
  computed: {
    ...mapState("fraccionesarancelarias", {
      fraccionesA: state => state.listaFA,
      totalPaginas: state => state.totalPaginas
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    })
  }
};
</script>

<style lang="css">
/* .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {

    height: auto;
} */
</style>
